export const LIGHT_THEME: string = 'light-theme';
export const DARK_THEME: string = 'dark-theme';

export const LOGIN_SUCCESS: string = "Login Successful!"
export const REGISTER_SUCCESS: string = "Register Successful!"
export const FIELDS_SHOULD_NOT_EMPTY: string = "Fields should not be empty"
export const ENTER_NAME: string = "Please enter you name!"
export const ENTER_EMAIL: string = "Please enter your email"
export const ENTER_PASSWORD: string = "Please enter your password"
export const ENTER_CONFIRM_PASSWORD: string = "Please enter confirm password"
export const PASSWORDS_NOT_MATCH: string = "Passwords do not match!"

export const LOGIN_API_URL: string = "/api/users/login"
export const REGISTER_API_URL: string = "/api/users/register"

export const LOCAL_STORAGE_INFO: string = "userInfo"
export const LS_GET_ITEM: string | null = localStorage.getItem(LOCAL_STORAGE_INFO)